// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import { Message, MessageBox, Notification, Loading } from 'element-ui';
var loadingInstance;
export default {
  // 消息提示
  msg: function msg(content) {
    Message.info(content);
  },
  // 错误消息
  msgError: function msgError(content) {
    Message.error(content);
  },
  // 成功消息
  msgSuccess: function msgSuccess(content) {
    Message.success(content);
  },
  // 警告消息
  msgWarning: function msgWarning(content) {
    Message.warning(content);
  },
  // 弹出提示
  alert: function alert(content) {
    MessageBox.alert(content, '系统提示');
  },
  // 错误提示
  alertError: function alertError(content) {
    MessageBox.alert(content, '系统提示', {
      type: 'error'
    });
  },
  // 成功提示
  alertSuccess: function alertSuccess(content) {
    MessageBox.alert(content, '系统提示', {
      type: 'success'
    });
  },
  // 警告提示
  alertWarning: function alertWarning(content) {
    MessageBox.alert(content, '系统提示', {
      type: 'warning'
    });
  },
  // 通知提示
  notify: function notify(content) {
    Notification.info(content);
  },
  // 错误通知
  notifyError: function notifyError(content) {
    Notification.error(content);
  },
  // 成功通知
  notifySuccess: function notifySuccess(content) {
    Notification.success(content);
  },
  // 警告通知
  notifyWarning: function notifyWarning(content) {
    Notification.warning(content);
  },
  // 确认窗体
  confirm: function confirm(content) {
    return MessageBox.confirm(content, '系统提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });
  },
  // 打开遮罩层
  loading: function loading(content) {
    loadingInstance = Loading.service({
      lock: true,
      text: content,
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  },
  // 关闭遮罩层
  closeLoading: function closeLoading() {
    loadingInstance.close();
  }
};